import { render } from "./ProductDetailPage.vue?vue&type=template&id=707837aa"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"
script.render = render

export default script